import React from 'react';
const Prev = () => (
    <svg width="44" height="45" viewBox="0 0 44 45" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="0.39624" width="44" height="44" rx="22" fill="url(#paint0_linear_13570_20592)" />
        <path d="M24.293 29.1034L17.5859 22.3963L24.293 15.6892L25.7073 17.1034L20.4144 22.3963L25.7073 27.6892L24.293 29.1034Z" fill="white" />
        <defs>
            <linearGradient id="paint0_linear_13570_20592" x1="-20.0406" y1="97.2537" x2="83.4037" y2="96.3852" gradientUnits="userSpaceOnUse">
                <stop stop-color="#24B04B" />
                <stop offset="1" stop-color="#0263BC" />
            </linearGradient>
        </defs>
    </svg>
);
export default Prev